import axios from 'axios'

import utils from '../../utils/utils'
let apiURL = '';

if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  // apiURL = 'https://api.frigg.haiweikexin.com'
  apiURL = 'http://proxy.jiankanghao.net:50226'
}else {
  apiURL = utils.decrypt(document.querySelector("html").getAttribute("api_frigg_url"))
}
//utils.decrypt(document.querySelector("html").getAttribute("api_frigg_url"))
let http = axios.create({
  timeout: 12000,
  baseURL: apiURL,
  headers: {'Content-Type': 'application/json'}
});

export default http;
